/**
 * El detalle vive en /store/orders/:id. La búsqueda del listado se recuerda
 * en la pestaña para que la miga y el atrás del móvil vuelvan a la misma vista.
 */

const KEY = 'aipeces.admin.storeOrders.listSearch';

function listHref(search: string): string {
    if (!search) return '/store/orders';
    if (search.startsWith('/')) return search;
    return `/store/orders${search.startsWith('?') ? search : `?${search}`}`;
}

export function rememberStoreOrdersListSearch(search: string): void {
    if (typeof sessionStorage === 'undefined') return;
    const value = search.startsWith('/') || search === '' || search.startsWith('?')
        ? search
        : `?${search}`;
    sessionStorage.setItem(KEY, value);
}

export function storeOrdersListHref(): string {
    if (typeof sessionStorage === 'undefined') return '/store/orders';
    return listHref(sessionStorage.getItem(KEY) ?? '');
}

/** La ficha abierta desde el listado trae la búsqueda en el estado de navegación. */
export function storeOrdersListHrefFrom(state: unknown): string {
    if (state && typeof state === 'object' && 'listSearch' in state) {
        const search = (state as { listSearch?: unknown }).listSearch;
        if (typeof search === 'string') return listHref(search);
    }
    return storeOrdersListHref();
}
